import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { RouterModule } from '@angular/router';

import { TabComponent } from './components/tab/tab.component';

@NgModule({
  declarations: [TabComponent],
  imports: [CommonModule, MatTabsModule, RouterModule],
  exports: [TabComponent],
})
export class TabModule {}
